import script from "./MaterialPageNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialPageNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MaterialPageNavigation.vue?vue&type=style&index=0&id=3c55c945&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c55c945"]])

export default __exports__